var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.result},[_c('h1',[_vm._v("Ты молодец!")]),_c('div',{class:_vm.$style.plate},[_vm._v(" Набрано "),_c('h1',[_vm._v(_vm._s(_vm.scoreNumber)+"/"+_vm._s(_vm.max))]),_vm._v(" "+_vm._s(_vm.scoreText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }